import React, { useEffect, useState } from 'react';
import ProductCategoryModel from './models/ProductCategoryModel';

function DeleteProductCategory({ CategoryData }) {
  const [selected, setSelected] = useState(new ProductCategoryModel());

  useEffect(() => {
    setSelected(CategoryData || new ProductCategoryModel());
  }, [CategoryData]);

  return (
    <div className="text-left px-2 pb-0">
      <h6>Following category will be deleted and cannot be recovered:</h6>
      <ul>
        <li>
          <b>Category Name:</b> {selected.CategoryName}
        </li>
        <li>
          <b>Slug:</b> {selected.Slug || 'N/A'}
        </li>
        <li>
          <b>Display Order:</b> {selected.DisplayOrder ?? 0}
        </li>
      </ul>
    </div>
  );
}

export default DeleteProductCategory;
